export type StationFinderEvent =
  | 'sf_page_view'
  | 'sf_cep_submitted'
  | 'sf_geolocation_used'
  | 'sf_band_shown'
  | 'sf_geocode_degraded'
  | 'sf_whatsapp_clicked'
  | 'sf_map_unavailable';

/* GTM forwards a dataLayer entry as URL-encoded form data, so a value has to survive
   that trip. Objects, arrays, functions and undefined do not, which is why the payload
   is flat and its values are scalars. */
export type AnalyticsValue = string | number | boolean | null;

export type AnalyticsPayload = Record<string, AnalyticsValue>;

declare global {
  interface Window {
    dataLayer?: AnalyticsPayload[];
  }
}

/* Sink is Firebase Analytics via the GTM dataLayer, same as lp-conquista. Without
   these events a drop in conversion caused by this page would be invisible. */
export const track = (event: StationFinderEvent, payload: AnalyticsPayload = {}): void => {
  try {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.push({ event, lp: 'station-finder', ...payload });
  } catch {
    // Analytics must never block the flow.
  }
};
